import React, { useCallback, useState } from 'react';

import api from '../../services/api';
import { useModal } from '../../hooks/modal';
import { useToast } from '../../hooks/toast';

import { CrossIcon } from '../../assets/svg/SVGComponents';
import PrimaryButton from '../../components/Buttons/PrimaryButton';
import SecondaryButton from '../../components/Buttons/SecondaryButton';

import {
  Actions,
  Body,
  CloseButton,
  Container,
  Description,
  Header,
  Title,
} from './styles';

interface IReinstateTeamModalProps {
  tournamentId: string;
  teamId: string;
  teamName: string;
  onSuccess: () => void;
}

const ReinstateTeamModal: React.FC<IReinstateTeamModalProps> = ({
  tournamentId,
  teamId,
  teamName,
  onSuccess,
}) => {
  const { closeModal } = useModal();
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);

  const handleReinstate = useCallback(async () => {
    setLoading(true);
    try {
      await api.patch(`/tournaments/${tournamentId}/teams/${teamId}/reinstate`);
      addToast({
        type: 'success',
        expression: 'Ação revertida',
        description: `A desclassificação da equipe ${teamName} foi revertida.`,
      });
      onSuccess();
      closeModal();
    } catch {
      addToast({
        type: 'error',
        expression: 'Erro',
        description: 'Não foi possível reverter a desclassificação.',
      });
    } finally {
      setLoading(false);
    }
  }, [tournamentId, teamId, teamName, onSuccess, addToast, closeModal]);

  return (
    <Container>
      <Header>
        <Title>Reverter Desclassificação</Title>
        <CloseButton type="button" onClick={closeModal}>
          <CrossIcon
            width="1rem"
            stroke="#6b7280"
            strokeWidth={2.5}
            fill="none"
          />
        </CloseButton>
      </Header>

      <Body>
        <Description>
          Deseja reverter a desclassificação da equipe{' '}
          <strong>{teamName}</strong>? Ela voltará à sua posição normal na
          classificação.
        </Description>

        <Actions>
          <SecondaryButton type="button" onClick={closeModal}>
            Cancelar
          </SecondaryButton>
          <PrimaryButton
            type="button"
            loading={loading}
            onClick={handleReinstate}
          >
            Reverter
          </PrimaryButton>
        </Actions>
      </Body>
    </Container>
  );
};

export default ReinstateTeamModal;
